// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__KViWQ","logo":"Nav_logo__1lujT"};